import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'striphtml',
  standalone: true
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string, replaceValue = '') {
    return value.replace(/<.*?>|&nbsp;|&amp;|&quot;/g, replaceValue);
  }
}
